import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  GoalsWrapper,
  SparksWrapper,
  GoalsDescription,
  ActionsContainer,
} from "./Styles";
import { EditGoalsIcon, ExportIcon } from "../../../Assets/SvgIcons";
import { SparkCard } from "../../../Components/SparkCard/SparkCard";
import { Link } from "react-router-dom";
import { Organization } from "../../../../redux/reducers/types";
import OrganizationEditModal from "../../Modal/OrganizationEditModal";
import { useOrganization } from "../../../hooks/useOrganization";
import { Box, Button, SimpleGrid } from "@chakra-ui/react";

type GoalsProps = {
  organization?: Organization;
};

export const Goals = ({ organization }: GoalsProps) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const getGoalForSpark = (spark) =>
    organization?.goals?.filter((goal) => goal.spark.name === spark) || [];

  const { isCurrentUserAdmin } = useOrganization();

  // Safety check: if organization is not available, show loading or empty state
  if (!organization) {
    return (
      <GoalsWrapper>
        <div style={{ textAlign: 'center', padding: '24px' }}>
          Loading organization data...
        </div>
      </GoalsWrapper>
    );
  }

  return (
    <GoalsWrapper>
      {organization?.sparks && organization.sparks.length > 0 && (
        <GoalsDescription>
          All goals of each spark are available to the public and can be viewed on
          your organizations profile.
        </GoalsDescription>
      )}
      {isCurrentUserAdmin && organization?.sparks && organization.sparks.length > 0 && (
        <ActionsContainer>
          <button onClick={() => setShowEditModal(true)}>
            <EditGoalsIcon /> Edit my sparks
          </button>
        </ActionsContainer>
      )}
      {!isCurrentUserAdmin && (
        <div style={{ marginBottom: '24px'}}></div>
      )}
      {organization?.sparks && organization.sparks.length === 0 && (
        <SimpleGrid
          mt={8}
          columns={{ base: 1, md: 2 }}
          spacing={4}
          alignItems="center"
          >
          <Box textAlign={{ base: "center", md: "left" }}>
            No sparks were added to this organization
          </Box>

          <Box display="flex" justifyContent={{ base: "center", md: "flex-start" }}>
            <Button
              ml={{ base: 0, md: 2 }} // 8px left margin on desktop only
              onClick={() => setShowEditModal(true)}
            >
              Add a spark
            </Button>
          </Box>
        </SimpleGrid>
      )}
      <SparksWrapper>
        {organization?.sparks?.map((spark) => (
          <Link
            key={spark}
            to={`/organizations/${organization.id}/sparks/${encodeURIComponent(
              spark
            )}/goals`}
            state={{ spark }}
          >
            <SparkCard
              name={spark}
              goalsCount={getGoalForSpark(spark)?.length}
            />
          </Link>
        ))}
      </SparksWrapper>
      {organization && (
        <OrganizationEditModal
          isOpen={showEditModal}
          onClose={() => setShowEditModal(false)}
          organization={organization}
          type={organization.type}
          step={"SPARK"}
        />
      )}
    </GoalsWrapper>
  );
};
